import React from "react";
import { Helmet } from "react-helmet";
import Navbar from '../components/navbar';
import TopBanner from '../components/top-banner';
import Footer from '../components/footer';
import About from "../components/about";
import MpVideo from "../components/mpvideo";
import WhatWeOffer from "../components/what-we-offer";
import SocialMediaFixed from "../components/socialmedia-fixed";


const AboutPage = () => {

    return (
        <>
            <Helmet>
                <title>About MP Holidays - Leading DMC for Madhya Pradesh Tourism</title>
                <meta name="description" content="MP Holidays is a trusted Destination Management Company (DMC) for Madhya Pradesh, offering expertly curated travel experiences including heritage, wildlife, pilgrimage, and adventure tours. Learn more about our commitment to seamless travel services." />
                <meta name="keywords" content="About MP Holidays, Madhya Pradesh DMC, MP travel agency, best tour operator MP, heritage tours MP, wildlife tours MP, pilgrimage tours MP, adventure tourism MP, travel experts MP, Madhya Pradesh tourism services" />
                <link rel="canonical" href="https://mpholidays.online/about" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "MP Holidays - Leading DMC for Madhya Pradesh",
                        "url": "https://mpholidays.online/about",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91 9319184060",
                            "contactType": "Customer Support"
                        },
                        "description": "MP Holidays is a professional Destination Management Company (DMC) offering top-notch travel services in Madhya Pradesh, including heritage, wildlife, pilgrimage, and adventure tours.",
                    })}
                </script>
            </Helmet>


            <TopBanner />
            <Navbar />
            <About />
            <WhatWeOffer />
            <MpVideo />
            <Footer />
            <SocialMediaFixed />

        </>
    );
};

export default AboutPage;
